<template>
    <div class="pos-relative" :class="{'form-group': !!label || !!hint || showErrorMessage}">
        <label v-if="label || hint"
               :for="id">

            {{formattedLabel}}

            <span v-if="tooltip"
                  class="fas fa-info-circle ml-1"
                  v-tooltip="tooltip"/>

            <br v-if="label && hint"/>

            <small v-if="hint"
                   class="text-secondary">
                {{hint}}
            </small>
        </label>

        <div v-if="addOnBefore || addOnAfter"
             class="input-group">
            <span v-if="addOnBefore">
                {{addOnBefore}}
            </span>
            <slot/>
            <span v-if="addOnAfter">
                {{addOnAfter}}
            </span>
        </div>
        <template v-else>
            <slot/>
        </template>

        <small v-if="showErrorMessage"
               class="text-danger">
            {{error}}
        </small>
    </div>
</template>

<script>
    import FieldWrapperProps from "../mixin/FieldWrapperProps";

    export default {
        name: "FieldWrapper",

        mixins: [FieldWrapperProps],

        computed: {
            formattedLabel() {
                if (!this.label) return null;

                let formatted = this.label.substr(0, 1).toUpperCase()
                    + this.label.substring(1).toLowerCase();

                return formatted.trim().indexOf(':') > 0 ? this.label : `${this.label}:`;
            },

            showErrorMessage() {
                return this.error && typeof this.error === 'string';
            }
        }
    }
</script>